import { AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { catchError, forkJoin, of, Subject, takeUntil } from 'rxjs';
import { Applications, ISignal, RolePermissionsModel } from '../../../../shared/models/app.model';
import { profileModificationModel, UPEnums, UPGeneralFields, UPSalesFields, UPServiceFields } from '../../model/user-profile.model';
import { CommonService } from '../../../../shared/services/common.service';
import { UserProfileService } from '../../services/user-profile.service';

@Component({
    selector: 'app-my-profile',
    templateUrl: './my-profile.component.html',
    styleUrl: './my-profile.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MyProfileComponent implements OnInit, AfterViewInit, OnDestroy {
  userId: string = '';
  UPGeneralFields: typeof UPGeneralFields = UPGeneralFields;
  showWindow: boolean = true;
  modifiedSections: any = {};
  enableSaveButton: boolean = false;
  @Output() closePopup = new EventEmitter();

  private destroy$: Subject<any> = new Subject();
  UPEnums: typeof UPEnums = UPEnums;
  action: Subject<ISignal>;
  UserProfileService: typeof UserProfileService = UserProfileService;
  isFormUpdated: boolean = false;
  PERMISSIONS: RolePermissionsModel[] = [];
  sectionsModified = {
    general: false,
    service: false,
    sales: false
  }
  lockAccountButtonText: string = 'Unlocked';
  isResetAuthDisabled: boolean = false;
  UPServiceFields: typeof UPServiceFields = UPServiceFields;
  UPSalesFields: typeof UPSalesFields = UPSalesFields;
  isCreatingNewUser: any;
  userProfile: any;
  initialLoad: boolean = true;


  constructor(private commonService: CommonService, private usersService: UserProfileService) {
    this.action = new Subject();
    this.modifiedSections[UPEnums.GeneralAddresses] = false;
    this.modifiedSections[UPEnums.GeneralFormData] = false;
    this.modifiedSections[UPEnums.GeneralProfilePic] = false;
    this.modifiedSections[UPEnums.ServicesFormData] = false;
    this.modifiedSections[UPEnums.ServicePreferencesData] = false;
    this.modifiedSections[UPEnums.SalesFormData] = false;
    this.modifiedSections[UPEnums.SalesAssignmentsData] = false;
    this.modifiedSections[UPEnums.SalesPreferencesData] = false;
  }
  ngOnInit(): void {
    this.checkMFAStatus();
    this.checkAccountStatus();
    this.getUserProfileData();
    this.handleSubjects();
  }
  handleSubjects() {
    this.usersService.hasGeneralFormSavedSuccessfuly.pipe(takeUntil(this.destroy$)).subscribe({
      next: res => {
        res && this.action.next({ action: 'saveAll', data: null });
      }
    });
    this.usersService.allCallsCompleted$.pipe(takeUntil(this.destroy$)).subscribe((allCompleted) => {
      if (allCompleted) {
        if(this.initialLoad && this.userProfile) {
          this.action.next({action: 'allSectionsLoaded', data: null});
          this.initialLoad = false;
        }
        UserProfileService.apiCallsInProgress = [];
      }
    });

  }
  getUserProfileData() {
    this.userProfile = this.commonService.getUSER();
    this.userId = this.userProfile.userId;
    this.loadPermissions();
  }

  ngAfterViewInit(): void {
  }
  checkAccountStatus() {
    this.usersService.apiCallStarted('checkAccountStatus');
    this.usersService.checkkAccountLock(this.userId).subscribe({
      next: (res: any) => {
        if(res?.result?.status == 'Unlocked') {
          this.lockAccountButtonText = res?.result?.status
        } else {
          this.lockAccountButtonText = 'Unlock Account'
        }
        this.usersService.apiCallCompleted('checkAccountStatus');
      },
      error: (err: any) => {
        this.commonService.showNotification('error', err?.error?.message);
        this.usersService.apiCallCompleted('checkAccountStatus');
      }
    });
  }

  unlockAccount() {
    this.usersService.apiCallStarted('unlockAccount');
    this.usersService.unlockAccount(this.userId).subscribe({
      next: (res: any) => {
        this.commonService.showNotification('info', res?.message);
        if(res?.result?.status == 'Unlocked') {
          this.lockAccountButtonText = res?.result?.status;
        }
        this.usersService.apiCallCompleted('unlockAccount');
      },
      error: (err: any) => {
        this.commonService.showNotification('error', err?.error?.message);
        this.usersService.apiCallCompleted('unlockAccount');
      }
    });
  }

  checkMFAStatus() {
    this.usersService.apiCallStarted("checkMFAStatus");
    this.usersService.checkMFAStatus(this.userId).subscribe({
      next: (res: any) => {
        if(res?.result?.status == 'Unset') {
          this.isResetAuthDisabled = false;
        } else {
          this.isResetAuthDisabled = true;
        }
        this.usersService.apiCallCompleted("checkMFAStatus");
      },
      error: (err: any) => {
        this.commonService.showNotification('error', err?.error?.message);
        this.usersService.apiCallCompleted("checkMFAStatus");
      }
    });
  }

  resetAuth() {
    this.usersService.apiCallStarted("resetAuth");
    this.usersService.resetMFA(this.userId).subscribe({
      next: (res: any) => {
        this.commonService.showNotification('info', res?.message);
        if(res?.result?.status == 'Unset') {
          this.isResetAuthDisabled = false;
        } else {
          this.isResetAuthDisabled = true;
        }
        this.usersService.apiCallCompleted("resetAuth");
      },
      error: (err: any) => {
        this.commonService.showNotification('error', err?.error?.message);
        this.usersService.apiCallCompleted("resetAuth");
      }
    });
  }
  setChangePasswordFlag() {
    this.usersService.apiCallStarted("setChangePasswordFlag");
    this.usersService.setChangePasswordFlag(this.userId).subscribe({
      next: (res: any) => {
        this.commonService.showNotification('info', res?.message);
        this.usersService.apiCallCompleted("setChangePasswordFlag");
      },
      error: (err: any) => {
        this.commonService.showNotification('error', err?.error?.message);
        this.usersService.apiCallCompleted("setChangePasswordFlag");
      }
    });
  }
  resetProfilePersistence() {
    this.usersService.apiCallStarted("resetProfilePersistence");
    this.usersService.clearPersistence(this.userId, '').subscribe({
      next: (res: any) => {
        this.commonService.showNotification('info', res?.message);
        this.usersService.apiCallCompleted("resetProfilePersistence");
        const USER = localStorage.getItem('USER');
        const token = localStorage.getItem('access_token');
        localStorage.clear();
        localStorage.setItem('USER', USER);
        localStorage.setItem('access_token', token);
      },
      error: (err: any) => {
        this.commonService.showNotification('error', err?.error?.message);
        this.usersService.apiCallCompleted("resetProfilePersistence");
      }
    });
  }
  getPermission(ruleAction: string): RolePermissionsModel {
    return this.PERMISSIONS?.find((e: RolePermissionsModel) => e.ruleAction === ruleAction)!;
  }
  loadPermissions(
    category: string = 'myProfile_Footer',
    subCategory: string = '',
    id: string = this.userProfile?.[UPGeneralFields.userId],
    module: string = 'userProfile'
  ) {
    this.commonService.getRolePermission(category, subCategory, module, id).subscribe({
      next: (res: any) => {
        this.PERMISSIONS = res?.result ?? [];
        this.PERMISSIONS.map((permission: RolePermissionsModel) => {
          permission.ruleAction = permission.ruleAction.replace('MP_', '').replace('UP_', '');
        });

        this.updatePagePermissions().then(() => {
        });
      },
      error: (err: any) => {
        this.PERMISSIONS = [];
      }
    });
  }
  updatePagePermissions(): Promise<boolean> {
    return new Promise((resolve) => {
      //do any action needed after permissions get reloaded.
        resolve(true);
    });
  }
  onProfileModified(e: profileModificationModel) {
    const isDataModified = e.modified;
    // const reloadPopup = !!e?.reloadPopup;
    const reloadPermissionsOnDataSave = !!e.updatedPermissiosParameters;
    this.modifiedSections[e.section] = isDataModified;
    let hasUnsavedChanges = Object.keys(this.modifiedSections).some(key => this.modifiedSections[key] === true);
    this.enableSaveButton = hasUnsavedChanges;
    if(reloadPermissionsOnDataSave) {
      this.action.next({ action: 'reloadPermissions', data: e.updatedPermissiosParameters });
    }
    this.userProfile = e.userProfile ?? [];
    // if(reloadPopup) {
    //   this.showWindow = false;
    //   setTimeout(() => {
    //     this.showWindow = true;
    //   }, 20);
    // }
  }

  checkUnsavedDataBeforeClosing() {
    let hasUnsavedChanges = Object.keys(this.modifiedSections).some(key => this.modifiedSections[key] === true);
    if(hasUnsavedChanges) {
      this.commonService.showConfirmation("Any unsaved changes will be lost, are you sure to close the popup?")
      .then(res => {
        if (res.isConfirmed) {
          this.closePopup.emit(true);
        }
      })
    } else {
      this.closePopup.emit(false);
    }
  }
  saveButtonClick() { // when the save button gets clicked.
    this.action.next({ action: 'checkValidations', data: null });
    this.usersService.apiCallStarted('checkUserProfileValidations');
    setTimeout(() => {
      if(this.usersService.invalidDataSections?.length == 0)
        {
          if(this.usersService.hasGeneralFormChanged) {
            this.action.next({ action: 'saveGeneralFormData', data: null });
          } else {
            this.action.next({ action: 'saveAll', data: null });
          }
        }
        this.usersService.apiCallCompleted('checkUserProfileValidations');
    }, 550);
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
